export const stageLifeCycleList = [
  {
    id: 1,
    name: 'Строительство',
  },
  {
    id: 2,
    name: 'Внутренняя приемка',
  },
  {
    id: 3,
    name: 'Приемка',
  },
  {
    id: 4,
    name: 'Управление',
  },
];

export const warrantyList = [
  {
    id: 0,
    name: 'Обычная',
  },
  {
    id: 1,
    name: 'Гарантия',
  },
  {
    id: 2,
    name: 'Возможно гарантия',
  },
];

export const enumFilter = {
  STAGE: 'stage',
  WARRANTY: 'warranty',
};
